module.exports = __webpack_public_path__ + "img/lja.c0fd16f9.jpg";